export const gcpDiskPaths = {
  list: (connectionId) => `/compute/cloud-account-connections/${connectionId}/gcp/disks`,
  snapshots: (connectionId) => `/compute/cloud-account-connections/${connectionId}/gcp/snapshots`,
  snapshotDetail: (connectionId, name) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/snapshots/${encodeURIComponent(name)}`,
  updateSnapshot: (connectionId, name) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/snapshots/${encodeURIComponent(name)}`,
  removeSnapshot: (connectionId, name) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/snapshots/${encodeURIComponent(name)}`,
  detail: (connectionId, scopeType, scope, name) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/disks/${encodeURIComponent(scopeType)}/${encodeURIComponent(scope)}/${encodeURIComponent(name)}`,
  update: (connectionId, scopeType, scope, name) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/disks/${encodeURIComponent(scopeType)}/${encodeURIComponent(scope)}/${encodeURIComponent(name)}`,
  remove: (connectionId, scopeType, scope, name) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/disks/${encodeURIComponent(scopeType)}/${encodeURIComponent(scope)}/${encodeURIComponent(name)}`,
  create: (connectionId) => `/compute/cloud-account-connections/${connectionId}/gcp/disks`,
  snapshot: (connectionId, scopeType, scope, name) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/disks/${encodeURIComponent(scopeType)}/${encodeURIComponent(scope)}/${encodeURIComponent(name)}/snapshot`,
  resize: (connectionId, scopeType, scope, name) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/disks/${encodeURIComponent(scopeType)}/${encodeURIComponent(scope)}/${encodeURIComponent(name)}/resize`,
};
